import { CinemaPartnerDto } from '@cineamo/api/models/cinema-partner/CinemaPartnerDto.types';
import { CinemaPartnerType } from '@cineamo/api/models/cinema-partner/CinemaPartnerType.enum';

import { CinemaPartnerListResponse } from '@cineamo/api/types/ApiListResponse.types';
import { ApiResponse } from '@cineamo/api/types/ApiResponse.types';

import { API_URL } from '@/constants/http-constants';

import apiClient from '@/utils/api/cineamoApiClient';

import { buildUrlQuery, UrlQueryParameter } from '@/helpers/url-query-helper';

export async function getCinemaPartnerById(cinemaPartnerId: number): Promise<ApiResponse<CinemaPartnerDto>> {
    return apiClient
        .get(`/cinema-partners/${cinemaPartnerId}`)
        .then((response) => response)
        .catch(() => {
            return null;
        });
}

export type GetCinemaPartnersQuery = {
    cinemaIds?: number[];
    types?: CinemaPartnerType[];
} & UrlQueryParameter;

export async function getCinemaPartners(
    params?: GetCinemaPartnersQuery
): Promise<ApiResponse<unknown, CinemaPartnerListResponse>> {
    return apiClient
        .get(`${API_URL}/cinema-partners${buildUrlQuery(params)}`, {
            credentials: 'same-origin'
        })
        .then((response) => response)
        .catch(() => {
            return null;
        });
}
